<template>
    <div class="m-common">
            <div class="common">
                <div v-if="resultRes">
                    <div class="control-height">
                        <!-- 纠错词 -->
                        <correct-word v-if="homonymName && pageNo == 1" :homonymName=homonymName></correct-word>
						<!-- 车展专题 -->
						<quick-topic v-if="quickTopicInfo.coverImgPc" :quickTopicInfo="quickTopicInfo">
						</quick-topic>
                        <!-- 推荐词 -->
                        <recommend :recommendWords=recommendWords v-if="recommendWords && recommendWords.length > 0 && pageNo == 1"></recommend>
                        <!-- 综合页顶部区域 -->
                        <div v-if="pageNo == 1">
                            <!-- 无结果时 -->
                            <index-tag v-if="type === 5" :tagWordArticle=tagWordArticle></index-tag>
                            <serial-head v-if="!isHaltSaleSerial && sid && type === 3" :serialData=serialData :sid=sid></serial-head>
                            <brand-head :bid=bid v-if="bid" ref="brand"></brand-head>
                            <vendor-head :vendorData=vendorData v-if="fid"></vendor-head>
                            <!-- 特殊情况,在fid为109和954的时候是同一个厂商S -->
                            <vendor-head :vendorData="And954109" v-if="And954109 && And954109.id"></vendor-head>
                            <!-- 特殊情况,在fid为109和954的时候是同一个厂商E -->
                            <serial-head v-if="isHaltSaleSerial && sid && type === 3" :serialData=serialData :sid=sid></serial-head>
                            <!-- 条件选车 -->
                            <condition v-if="type === 4 && conditionData.items && conditionData.items.length > 0" :conditionData=conditionData></condition>
                            <!-- 相关品牌 -->
                            <!-- <related-brand v-if="relatedBrandInfo" :list="relatedBrandInfo.brandVO"></related-brand> -->
                            <!-- 相关车系 -->
                            <!-- <related-series v-if="relatedSeriesInfo" :list="relatedSeriesInfo.serialVO"></related-series> -->
                            <!-- 相关厂商 -->
                            <!-- <related-manufacture v-if="relatedManufactureInfo" :list="relatedManufactureInfo.manufactureVO"></related-manufacture> -->
                        </div>
                        <!-- 行家作者 -->
                        <author :expertAuthor=expertAuthor v-if="expertAuthor && expertAuthor.authorId && pageNo == 1"></author>
                        <!-- 语义词-专属位置 -->
                        <div>
                            <market :marketData=marketData v-if="marketData.list && marketData.list.length > 0  && pageNo == 1 && semanticAttr==='price'"></market>
                            <picture-area :photoData="photoData" v-if="photoData && photoData.id && pageNo == 1 && semanticAttr==='photo'"></picture-area>
                            <article-area :cmsArticleData=cmsArticleData v-if=" cmsArticleData && cmsArticleData.length > 0 && semanticAttr==='cms'"></article-area>
                            <video-area :videoResult=videoResult v-if="videoResult && pageNo == 1 && semanticAttr==='video'"></video-area>
                            <bbs-head :bbsInfo=bbsInfo v-if="bbsInfo && bbsInfo.forumId && pageNo == 1 && semanticAttr==='bbs'"></bbs-head>
                        </div>
                        <!-- 图片区域 -->
                        <picture-area :photoData="photoData" v-if="photoData && photoData.id && pageNo == 1 && !semanticAttr"></picture-area>
                        <!-- 百科区域 -->
                        <baike v-if="knowledge && pageNo == 1" :knowledge=knowledge></baike>
                        <!-- 文章区域 -->
                        <article-area :cmsArticleData=cmsArticleData v-if=" cmsArticleData && cmsArticleData.length > 0 && semanticAttr != 'cms'"></article-area>
                        <!-- 论坛 -->
                        <bbs-head :bbsInfo=bbsInfo v-if="bbsInfo && bbsInfo.forumId && pageNo == 1 && semanticAttr != 'bbs'"></bbs-head>
                        <!-- 评论区 -->             
                        <review :commontInfo=commontInfo v-if="commontInfo.id && pageNo == 1"></review>
                        <!-- 行情区域 -->
                        <market :marketData=marketData v-if="marketData.list && marketData && marketData.list.length > 0 && pageNo == 1 && semanticAttr != 'price'"></market>
                        <!-- 视频区域 -->
                        <video-area v-if="videoResult && pageNo == 1 && semanticAttr != 'video'" :videoResult=videoResult></video-area>
                        <!-- 太平洋号区域 -->
                        <pacific-ocean :expertResult=expertResult v-if="expertResult && pageNo == 1"></pacific-ocean>
                        <!-- 底部相关搜索区域 -->
                        <relevant-search :relationSearch=relationSearch v-if="relationSearch && relationSearch.length > 0"></relevant-search>
                    </div>
                    <!-- 分页符 -->
                    <paging :totalPages=totalPages v-if="totalPages" @reqData=reqComposite></paging>
                    <search-box :id="2"></search-box>
            </div>
            <error-acrticle v-else :id="4247"></error-acrticle>
        </div>
            <!-- 侧边栏区域 -->
            <common-side :propsASid=aSid :propsCurrentPage=pageNo :propsRightHots=hotTagWord :RightCarsConcern=RightCarsConcern :propsRelateTagWord=relateTagWord :serailRightData=serailRightData :propsOtherBaike=othersBaike :propsClueData=propsClueData :RightBrandOrVendorMyConcern=RightBrandOrVendorMyConcern :brandOrVendorRightData=brandOrVendorRightData></common-side>
    </div>

</template>

<script>
import BrandHead from './BrandHead'
import PictureArea from './PictureArea'
import ArticleArea from './ArticleArea.vue'
import Market from './Market.vue'
import VideoArea from './VideoArea.vue'
import PacificOcean from './PacificOcean.vue'
import RelevantSearch from './RelevantSearch.vue'
import Baike from '../../global/Baike.vue'
import CommonSide from '../../sides/Common'
import Recommend from './Recommend.vue'
import VendorHead from './VendorHead.vue'
import SerialHead from './SerialHead.vue'
import Review from './Review'
import SearchBox from '../../global/pageTop/searchBox.vue'
import BbsHead from '../../global/BbsHead.vue'
import Condition from './Condition.vue'
import IndexTag from './IndexTag.vue'
import ErrorAcrticle from '../../global/ErrorAcrticle.vue'
import RelatedBrand from './relatedBrand.vue'
import RelatedSeries from './relatedSeries.vue'
import RelatedManufacture from './relatedManufacture.vue'
import QuickTopic from './QuickTopic.vue'
    export default {
        components: { 
            BrandHead, 
            PictureArea, 
            ArticleArea, 
            Market, 
            VideoArea, 
            PacificOcean, 
            RelevantSearch, 
            Baike, 
            CommonSide, 
            Recommend, 
            VendorHead, 
            SerialHead, 
            Review, 
            SearchBox, 
            BbsHead, 
            Condition, 
            IndexTag, 
            ErrorAcrticle,
            RelatedBrand,
            RelatedSeries,
            RelatedManufacture,
			QuickTopic
        },
        name: 'Common',
        data() {
            return {
                commonEntitesData: [], // 综合筛选类型结果
                mainRelatedInfo: {}, // 各类型的主要和相关列表的对象结构 { type: { main. relates } }
                recommendWords: null, //为你推荐:推荐词
                knowledge: null, //百科模块数据
                homonymName: '', //同音词
                compositeData: {},//综合页数据
                bid: 0, //品牌id
                fid: 0, //厂商id
                sid: 0, //车系id
                aSid:"", // string 车系id
                vendorData: {}, //厂商数据
                And954109: {}, //厂商id954或者109的时候同时请求的数据(请求954则需要再请求109,反之亦然)
                isHaltSaleSerial: false, // 是否是停售车系
                serialData: {}, //车系数据
                serialMinPrice: {}, //对应本地车系最低价
                marketData: {}, //行情数据
                cityName: '', //城市名字
                photoData: {}, //品牌区域数据
                cmsArticleData: [], //cms文章数据
                type: 0, //结果类型
                bbsInfo: {}, //论坛信息
                commontInfo: {}, //点评信息
                expertResult: [], //太平洋号数据
                videoResult: [], //视频数据
                relationSearch: [], //相关搜索
                totalPages: 0, //综合页页数
                othersBaike: [], //百科数据
                expertAuthor: {}, //太平洋作者
                pageNo: 1, //当前页数
                conditionData: {}, //条件选车数据
                urlWapParam: '', //选车条件分离判断的跳转依据
                propsClueData: [], //右侧车友会数据-只在第一面显示
                TempPropsClueData: [], //临时变量,在请求其他数据不存在的时候进行负责给propsClueData
                RightBrandOrVendorMyConcern: [], //厂商或者品牌的可能关注
                RightCarsConcern: [], //右侧车系数据
                tagWordArticle: {}, //无结果时的标签词
                relateTagWord: [], //相关标签
                hotTagWord: [], //右侧热门推荐
                serailRightData: {}, //车系专区模块数据
                brandOrVendorRightData:{}, //右侧品牌或厂商数据
                semanticAttr: "", //语义词,用作将对应模块提前 例:奥迪图片->semanticAttr: "photo" 将图片模块提前
                resultRes: {}, //综合页数据
                relatedBrandInfo: {}, // 相关品牌
                relatedSeriesInfo: {}, // 相关车系
                relatedManufactureInfo: {}, // 相关厂商
				quickTopicInfo: {
					coverImgPc:""
				} // 快速专题
            }
        },
        watch: {
            mainRelatedInfo: {
                handler(newValue) {
                    if (newValue && Object.keys(newValue).length) {
                        const mrInfo = newValue
                        const seriesRelates = mrInfo[3] && mrInfo[3].relates || []
                        const brandRelates = mrInfo[1] && mrInfo[1].relates || []
                        const manufactureRelates = mrInfo[2] && mrInfo[2].relates || []
                        const serialIds = seriesRelates.map(item => item.id)
                        const brandIds = brandRelates.map(item => item.id)
                        const manufactureIds = manufactureRelates.map(item => item.id)
                        this.fetchRelatedSerialAndBrand({ serialIds, brandIds, manufactureIds })
                    }
                },
                immediate: true
            }
        },
        methods: {
            //请求综合页数据
            async reqComposite(pageNo=1) {
                try {
                    const res = await this.fetComposite({
                        q:this.$global.q, // 搜索词
                        enableHomonym:this.$global.enableHomonyn, // 使用同音词搜索
                        rid:this.$global.rid, // 地区id
                        pageNo // 页码
                    })
                    this.recommendWords = res.recommendWords // 搜索框下的推荐词
                    this.homonymName = res.homonymName // 同音词
                    this.type = res.type  // 识别类型，1=品牌，2=厂商，3=车系，4=筛选条件，5=无匹配
                    this.pageNo = pageNo
                    this.$global.qType = res.type
                    this.resultRes = res
                    if(res.clubSubject && res.clubSubject.clubSubjectInfo) {
                        this.TempPropsClueData = res.clubSubject.clubSubjectInfo.subjectList
                    }
                    let id = res.id // 结果id
                    let type = res.type // 结果类型
                    let rid = this.$global.rid //城市id
                    let rname = res.rname;
                    let cityId = Number(rid);
                    let markListData = {
                        serialGroupId: 0, // 车系ID
                        pageNo: 1, // 页码	number	1	
                        isAsc: 0, // 是否升序	number	1：是，0：否	
                        priceLower: 0, // 价格下限	number		
                        kindId: 0, // 级别ID	number		
                        priceUpper: 0, // 价格上限	number		
                        sort: 3, // 排序参数，0按降幅；1按促销价，2行情创建时间；3车型热度+经销商指数分	number	3	
                        manuId: 0, // 厂商ID	number		
                        cityId: cityId, // 城市ID	number		
                        brandId: 0, // 品牌ID	number		
                        provinceId: 0, // 省份ID	number		
                        modelId: 0 // 车型ID	number		
                    }
                    // 品牌
                    if(type === 1) {
                        if(this.pageNo == 1) {
                            markListData.brandId = id;
                            this.reqIndexBrand(id)
                            this.reqIndexBrandPhoto(id)
                            this.reqIndexMarket(markListData, rname)
                            this.reqBaike(false)
                            this.brandOrVendorRightData = {} //返回第一页的时候需要清空展示的数据
                        }else {
                            this.reqRightBrand(id)
                        }
                        this.reqBrandConcern(id)
                    // 车系
                    }else if (type === 2) {
                        if(this.pageNo == 1) {
                            markListData.manuId = id;
                            this.reqIndexVendor(id)
                            this.reqIndexMarket(markListData, rname)
                            this.reqIndexVendorPhoto(id)
                            this.reqBaike(false)
                            this.reqVdendorConcern(id)
                            this.brandOrVendorRightData = {} //返回第一页的时候需要清空展示的数据
                        }else {
                            this.reqRightVendor(id)
                        }
                        // this.reqBrandConcern(id)
                    // 厂商
                    }else if(type === 3) {
                        this.aSid = id
                        if(this.pageNo == 1) {
                            markListData.serialGroupId = id;
                            this.reqIndexSerial(id, rid)
                            this.reqIndexMarket(markListData, rname)
                            this.reqIndexSerialPhoto(id)
                            this.reqIndexBbsInfo(id)
                            this.reqIndexComment(id)
                            this.reqRightCarsConcern(id)
                            this.reqBaike(false)
                            this.serailRightData = {} //第一页的时候重置数据
                        }else {
                            this.reqRightCars(id,rid)
                        }
                    // 条件选车
                    }else if(type === 4) {
                        if(this.pageNo === 1) {
                            this.reqHj()
                            this.urlWapParam = res.urlWapParam
                            this.reqIndexTagWord()
                            if(res.optionSerialInfoUrl) {
                                this.reqIndexConditionUrl(res.optionSerialInfoUrl)
                            }
                        } else {
                            this.propsClueData = [] //返回第一页的时候需要清空数据
                            this.othersBaike = [] //返回第一页的时候需要清空数据
                        }
                    // 无匹配
                    }else if(type === 5) {
                        if(this.pageNo === 1) {
                            this.reqIndexTagWord()
                        } else {
                            this.propsClueData = [] //返回第一页的时候需要清空数据
                        }
                    }
                     if( this.pageNo == 1 ){
                        this.reqHj()
                    }
                    this.cmsArticleData = res.cmsAndVideoResult
                    this.expertResult = res.expertResult
                    this.videoResult = res.videoResult
                    this.relationSearch = res.relationSearch
                    this.cityName = res.rname
                    this.totalPages= res.totalPage
                    this.semanticAttr = res.semanticAttr
                    if(res) {
                        document.body.scrollTop = document.documentElement.scrollTop = 0
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            // 获取综合tab下匹配类型数据
            async  reqCommonEntities() {
                try {
                    const entitiesData = await this.fetCommonEntities({
                        q:this.$global.q // 搜索词
                    })
                    // console.log('新综合接口', entitiesData)
                    this.commonEntitesData = entitiesData || []
                    // 有匹配品牌，同时展示品牌
                    const brandData = this.commonEntitesData.find(item => item.entityType === 1 && item.score === 1)
                    if (brandData) {
                        this.reqIndexBrand(brandData.id)
                    }
                    // 是否有停售车系
                    const serialData = this.commonEntitesData.find(item => item.entityType === 3 && item.score === 1)
                    this.isHaltSaleSerial = serialData && serialData.info && serialData.info.sell_status === 1
                    // 获取各类型的主要和相关列表的对象结构 { type: { main. relates } }
                    this.getMaiRelatedTypeResult()
                } catch (error) {
                    console.error(error)
                }
                
            },
            //请求条件选车
            async reqIndexConditionUrl(optionSerialInfoUrl) {
                try {
                        const conditionData =  await this.fetIndexConditionUrl(optionSerialInfoUrl)
                        let tempc = conditionData 
                        tempc.urlWapParam = this.urlWapParam
                        this.conditionData = tempc
                    } catch (error) {
                        console.error(error)
                    }
            },
            //请求综合页品牌信息
            async reqIndexBrand(bid) {
                try {
                    const res = await this.fetIndexBrand({ bid }) 
                    this.bid = res.id
                    if(res) {
                        this.$nextTick(()=>{
                            if(this.$refs.brand) {
                                this.$refs.brand.reqBrand()
                            }
                        })
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //请求品牌图片信息
            async reqIndexBrandPhoto(bid) {
                try {
                    const res = await this.fetIndexBrandPhoto({
                        bid
                    })
                    this.photoData = res
                } catch (error) {
                    console.error(error)
                }
            },
            //请求综合页厂商信息
            async reqIndexVendor(fid) {
                try {
                    const res = await this.fetIndexVendor({ fid }) 
                    this.fid = res.id
                    this.vendorData = res
                    if(fid == 109) {
                        const res1 = await this.fetIndexVendor({ fid:954 })
                        this.And954109 = res1
                    }else if(fid == 954 ) {
                        const res2 = await this.fetIndexVendor({ fid:109 })
                        this.And954109= res2
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //请求厂商图片信息
            async reqIndexVendorPhoto(fid) {
                try {
                    const res = await this.fetIndexVendorPhoto({
                        fid
                    })
                    this.photoData = res
                } catch (error) {
                    console.error(error)
                }
            },
            //请求综合页车系信息
            async reqIndexSerial(sid,city = 1) {
                try {
                    const res = await this.fetIndexSerial({ sid }) 
                    let subsidyList = {}
                    /* if(res.isNewPower == 1){
                        // 车系补贴
                        const btres = await this.fetchSerialGroupBtPrice({sid, cid:city})
                        // 车型补贴价
                        const priceListRes = await this.fetchSerialGroupBtPriceList({sid: sid, rid: city})
                        res.btPriceRange = (btres && btres.data && btres.data.btPriceRange) || ''
                        if(priceListRes){
                            priceListRes.data.subsidyList.map(v => {
                                subsidyList[v.id] = v.btPrice
                            })
                        }
                    } */
                    // 优惠
                    const discountRes = await this.fetchMaxDiscount({serialGroupIds: sid, cityId:city})
                    if(discountRes && discountRes.code == 0 && discountRes.data && discountRes.data.list.length > 0){
                        res.discount_link = `https://price.pcauto.com.cn/market/${discountRes.data.list[0].dealerId}-${discountRes.data.list[0].newsId}.html` 
                        res.discount = '↓' + parseFloat(discountRes.data.list[0].maxDiscount/10000) + '万'
                    }
                    // 获取经销商报价
                    const priceRes = await this.fetchLowestModelPrice({serialGroupId: sid, cityId:city})
                    if(priceRes && priceRes.code == 0 && priceRes.data && priceRes.data.minPrice && priceRes.data.minPrice != 0){
                        res.d_price =  priceRes.data.minPrice + '-' + priceRes.data.maxPrice + '万'
                        res.d_price_link = `https://price.pcauto.com.cn/market/r${city}/sg${sid}/`
                    }
                    this.sid = res.id
                    this.serialData = res
                    if(res) {
                      this.reqSerialMinprice(priceRes,subsidyList)
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //请求车系图片信息
            async reqIndexSerialPhoto(sid) {
                try {
                    const res = await this.fetIndexSerailPhoto({
                        sid
                    })
                    this.photoData = res
                 } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块厂商专区模块数据 
            async reqRightVendor(fid) {
                try {
                    const res = await this.fetRightVendor({
                        fid
                    })
                    this.brandOrVendorRightData = res
                } catch (error) {
                    console.error(error)
                }
            },             
            //本地车系对应最低价，及补贴价
            async reqSerialMinprice(res,btList) {
                try {
                    console.log(res,'请求本地车系对应最低价',btList)
                    /* 处理新增字段,匹配是否存在本地最低价S */ 
                    let newTabs = this.serialData.tabs
                    let minPrice = {}
                    if(res.code == 0) {
                        minPrice = res.data.price
                    }
                    newTabs.map(v => {
                        v.models.map(p => {
                            if(minPrice[p.id]) {
                                p.min_price = minPrice[p.id] + '万' //如果匹配到最低本地车系价格替换原数据的min_price
                            }
                            if(btList[p.id]) {
                                p.btPrice = btList[p.id] + '万' //如果匹配到车系补贴价格替换原数据的btPrice
                            }
                        })
                    })
                    this.serialData.tabs = newTabs //将结果数据的tabs替换成新的
                    /* 处理新增字段,匹配是否存在本地最低价E */ 
                    this.serialMinPrice = res.data
                } catch (error) {
                    console.error(error)
                }
            },
            //请求综合页车系时的论坛
            async reqIndexBbsInfo(sids) {
                try {
                    const res = await this.fetIndexBbsInfo({
                        sids
                    })
                    this.bbsInfo = res[0]
                } catch (error) {
                    console.error(error)
                }
            },
            //请求综合页车系时的论坛
            async reqIndexComment(sid) {
                try {
                    const res = await this.fetIndexComment({
                        sid
                    })
                    this.commontInfo = res
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块车系可能关注模块数据 
            async reqRightCarsConcern(sid) {
                try {
                    const res = await this.fetRightCarsConcern({
                        sid
                    })
                    this.RightCarsConcern = res
                } catch (error) {
                    console.error(error)
                }
            },            
            //请求右侧豆腐块条件选车豆腐块的可能关注
            async reqBaike(isShowOthersBaike=true) {
                try {
                    const res = await this.fetBaike({
                        q:this.$global.q,
                        enableHomonyn:this.$global.enableHomonyn
                    })
                    this.knowledge = res.knowledge
                    if(isShowOthersBaike) {
                        if(res.knowledge) {
                            this.othersBaike = res.knowledge.othersBaike
                        }
                    }
                } catch (error) { 
                    console.error(error)
                }
            },
            //请求右侧豆腐块品牌可能关注模块数据 
            async reqBrandConcern(bid) {
                try {
                    const res = await this.fetBrandConcern({
                        bid
                    })
                    this.RightBrandOrVendorMyConcern = res
                } catch (error) {
                    console.error(error)
                }
            }, 
            //请求右侧豆腐块厂商可能关注模块数据 
            async reqVdendorConcern(fid) {
                try {
                    const res = await this.fetVdendorConcern({
                        fid
                    })
                    this.RightBrandOrVendorMyConcern = res
                } catch (error) {
                    console.error(error)
                }
            },                           
            
            //请求综合页行情模块
            async reqIndexMarket(data, rname) {
                try {
                    const res = await this.fetIndexMarket(data)
                    if(res && res.data && res.data.list.length > 0){
                        let tempMarketData = res.data,
                        list = tempMarketData.list;
                        tempMarketData.cityName = rname;
                        tempMarketData.name = this.$global.q;
                        tempMarketData.more_reduce_price_link = 'http://price.pcauto.com.cn/market/r1/sg' + list[0].serialGroupId +"/"
                        for(var i=0;i<list.length; i++){
                            tempMarketData.list[i].delearLink = `//price.pcauto.com.cn/${list[i].dealerId}/`
                            tempMarketData.list[i].link = `//price.pcauto.com.cn/market/${list[i].dealerId}-${list[i].newsId}.html`
                        }
                        this.marketData = tempMarketData
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            
            //请求综合标签词
            async reqIndexTagWord() {
                try {
                    const res = await this.fetIndexTagWord({
                        name:this.$global.q
                    })
                    if(res.code === 200) {
                        if(this.type === 5) {
                            let tempTag = {}
                            tempTag.tagWord = res.data.tagWord
                            tempTag.items = res.data.tagWordArticle
                            this.tagWordArticle = tempTag
                            this.relateTagWord = res.data.relateTagWord
                            this.hotTagWord = res.data.hotTagWord
                        }
                        if(res.data.tagWord) {
                            this.reqBaike(false)
                        }else{
                            if(this.pageNo === 1) {
                                this.propsClueData = this.TempPropsClueData
                                if(this.type != 5) {
                                    this.reqBaike()
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块品牌专区模块数据 
            async reqRightBrand(bid) {
                try {
                    const res = await this.fetRightBrand({
                        bid
                    })
                    this.brandOrVendorRightData = res
                } catch (error) {
                    console.error(error)
                }
            },            
            //请求右侧豆腐块车系专区模块数据
            async reqRightCars(sid,city) {
                try {
                    const res = await this.fetRightCars({
                        sid,
                        city
                    })
                    this.serailRightData = res
                } catch (error) {
                    console.error(error)
                }
            },            
            //太平洋号作者
             async reqHj(pageNo = 1) {
                 try {
                     const res = await this.fetHj({
                         q:this.$global.q,
                         pageNo
                     })
                     this.expertAuthor = res.expertAuthor
                 } catch (error) {
                    console.error(error)
                 }
            },
            // 获取相关车系、相关品牌、相关厂商
            async fetchRelatedSerialAndBrand({ serialIds = [], brandIds = [], manufactureIds = [] }) {
                if (!serialIds.length && !brandIds.length && !manufactureIds.length) return
                try {
                    const res = await this.fetchHotWord({
                        serialIds: serialIds || [],
                        brandIds: brandIds || [],
                        manufacturerIds: manufactureIds || [],
                        word: this.$global.q,
                        cityId: this.$global.rid,
                    })
                    if (res && res.code === 200) {
                        const data = res && res.data || {}
                        this.relatedSeriesInfo = data && data.serialInfo || {}
                        this.relatedBrandInfo = data && data.brandInfo || {}
                        this.relatedManufactureInfo = data && data.manufactureInfo || {}
                    } else {
                        this.relatedSeriesInfo = {}
                        this.relatedBrandInfo = {}
                        this.relatedManufactureInfo = {}
                    }
                } catch (e) {
                    console.log(e)
                }
            },
            // 获取各类型的主要和相关列表的对象结构 { type: { main. relates } }
            getMaiRelatedTypeResult() {
                let mainRelatedObj = {}
                let typeResult = this.commonEntitesData.reduce((pre, cur) => ({
                    ...pre,
                    [cur.entityType]: (pre[cur.entityType] || []).concat(cur)
                }), {})
                for (const type in typeResult) {
                    const resultList = typeResult[type]
                    const scoreList = resultList.filter(m => m.score === 1)
                    if (scoreList.length > 1) {
                    mainRelatedObj[type] = {
                        main: {},
                        relates: scoreList
                    }
                    } else if (scoreList.length === 1) {
                    mainRelatedObj[type] = {
                        main: scoreList[0],
                        relates: []
                    }
                    } else {
                    mainRelatedObj[type] = {
                        main: {},
                        relates: resultList
                    }
                    }
					// 判断有没有快速专题
					if (resultList.length>=1 && resultList[0].entityType && resultList[0].entityType === 11){
						this.quickTopicInfo = resultList[0].info || {}
						this.quickTopicInfo.name = resultList[0].name || ''
					}
                }
                this.mainRelatedInfo = mainRelatedObj
            },
        },
        mounted() {
            // if(this.$global.tab.title == 'auto_index') {
            this.countColumnAd(3447)
            this.reqCommonEntities()
            this.reqComposite()
            // this.$EventBus.$on(`${this.$global.tab.title}`,() => {this.reqComposite()})

            // }
        },
    }
</script>

<style lang="scss">
.m-common {
    display: flex;
    justify-content: space-between;
    width: 1000px;
}
.common {
    width: 620px;
    position: relative;
}
</style>